import {all, call, put, takeLatest} from 'redux-saga/effects';
import {
  getAirportList,
  setAirportList,
  setAirportListError
} from "../../reducers/airportReducer/airportReducer";
import {API} from "../../../API/API";
import {AirportApiAirportListRequest, AirportApiAirportListResponse, PageModel} from "../../../proto/generated/api_entities_pb";
import {InitialPage} from "../../../utils/constans/pagination/pagination";
import {PageModelLimits} from "../../../utils/constans/pagination/pageModelLimits";
import {DebounceSelectOptionProps} from "../../../components/UI/AntCustom/DebounceSelect";

function* getAirportListSaga() {
  try {
    // Загружаем первые 100 аэропортов без фильтрации (пустой query)
    const req = new AirportApiAirportListRequest()
      .setQuery('')
      .setPagemodel(
        new PageModel().setPage(InitialPage).setLimit(100) // Загружаем только первые 100 аэропортов
      );
    
    const res: AirportApiAirportListResponse = yield call(API.getAirportList, req);
    
    const airports: DebounceSelectOptionProps[] = res.getAirportsList().map(a => ({
      key: a.getAirportid(),
      label: `${a.getIcaocode() ? a.getIcaocode() + ", " : ""}${a.getIatacode() ? a.getIatacode() + ", " : ""}${a.getName()}`,
      value: a.getAirportid(),
    }));
    
    yield put(setAirportList({airports}));
  } catch (error: any) {
    yield put(setAirportListError({
      errorMessage: error?.message || 'Failed to load airports'
    }));
  }
}

export function* airportSaga() {
  yield all([
    takeLatest(getAirportList.type, getAirportListSaga),
  ]);
}
